import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getDataFromCookies } from "utilities/getCookiesData";

const AuthLayout = () => {
  const token = getDataFromCookies("token");
  const location = useLocation();

  return token && token.length > 0 ? (
    <Outlet />
  ) : (
    <Navigate
      to="/register"
      replace
      state={{ from: location }} // <-- current location so login can redirect back is desired
    />
  );
};

export default AuthLayout;
